import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CurrentTransactionService } from '@orderna/admin-panel/src/app/services/shared/current-transaction/current-transaction.service';
import { CancelTransactionConfirmComponent } from '../cancel-transaction-confirm/cancel-transaction-confirm.component';
import { ParkTransactionModalComponent } from '../park-transaction-modal/park-transaction-modal.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'app-pos-transaction-controls',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltip],
  templateUrl: './transaction-controls.component.html',
  styleUrl: './transaction-controls.component.scss',
})
export class TransactionControlsComponent {
  #cart = inject(CurrentTransactionService);
  #dialog = inject(MatDialog)

  voidable = this.#cart.voidable;
  valid = this.#cart.valid;

  voidTransaction() {
    this.#dialog.open(CancelTransactionConfirmComponent);
  }

  parkTransaction() {
    this.#dialog.open(ParkTransactionModalComponent);
  }
}
